module.exports = __webpack_public_path__ + "img/footer-fax.26cb4757.png";